<template>
  <div
    class="modal fade"
    id="renew-account-profile"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <LoadingElement v-if="loading" />
      <button
        v-if="loading"
        type="button"
        class="btn-close hidden"
        data-bs-dismiss="modal"
        aria-label="Close"
        id="renew-account-close"
      ></button>
      <div v-if="!loading && temp_profile" class="modal-content">
        <div class="modal-body p-4">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2">{{ $t("accounts.renew_subscription") }}</h4>
          </div>

          <form class="row g-4">
            <div class="col-12">
              <label class="form-label">{{ $t("accounts.username") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-user"></i></div>
                <input
                  type="text"
                  class="form-control"
                  :value="selectedAccount.username"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label" for="multicol-country">{{
                $t("profiles.profile")
              }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-wifi-2"></i></div>
                <select
                  class="select2 form-select"
                  v-model="selectedAccount.profile.id"
                  @change="
                    updateExpiration();
                    updateProfile();
                    validate();
                  "
                  :disabled="!hasPrivilege('accounts_edit_profile_accounts')"
                >
                  <option
                    v-for="(profile, index) in profiles"
                    :key="profile.id"
                    :value="profile.id"
                    >{{ profile.name }}</option
                  >
                </select>
              </div>
            </div>

            <div class="col-md-6" v-if="this.user.type != 'reseller'">
              <label class="form-label" for="multicol-country">{{
                $t("profiles.next_profile")
              }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-wifi-2"></i></div>
                <select
                  v-model="selectedAccount.next_profile_id"
                  class="select2 form-select"
                  :disabled="
                    !hasPrivilege('accounts_edit_next_profile_accounts')
                  "
                >
                  <option :value="null">N/A</option>
                  <option
                    v-for="(profile, index) in profiles"
                    :key="profile.id"
                    :value="profile.id"
                    >{{ profile.name }}</option
                  >
                </select>
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label" for="basic-icon-default-email">{{
                $t("profiles.renew.amount")
              }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-clock"></i></div>
                <input
                  type="number"
                  class="form-control"
                  placeholder="1"
                  aria-label="1"
                  @input="
                    validate();
                    updateExpiration();
                  "
                  :disabled="!add_days"
                  v-model="renew_amount"
                  aria-describedby="basic-icon-default-email2"
                  :class="{ 'is-invalid': errors.renew_amount }"
                />
                <span class="input-group-text">{{
                  $t(`accounts.unit.${selectedAccount.profile.expiration_unit}`)
                }}</span>
                <div v-if="errors.renew_amount" class="invalid-feedback">
                  {{ errors.renew_amount }}
                </div>
              </div>
            </div>

            <div
              class="col-md-6"
              v-if="
                hasPrivilege('accounting_pay_bill') && user.type != 'reseller'
              "
            >
              <label class="form-label d-block">{{
                $t("profiles.renew.payment_status")
              }}</label>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    in_debt === true ? 'btn-success' : 'btn-outline-success'
                  "
                  @click="in_debt = true"
                >
                  {{ $t("profiles.renew.paid") }}
                </button>

                <button
                  type="button"
                  class="btn w-100"
                  :class="
                    in_debt === false ? 'btn-danger' : 'btn-outline-danger'
                  "
                  @click="in_debt = false"
                >
                  {{ $t("profiles.renew.in_debt") }}
                </button>
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label" for="basic-icon-default-phone">{{
                $t("profiles.price")
              }}</label>
              <div class="input-group input-group">
                <span class="input-group-text"
                  ><i class="ti ">{{ settings.currency }}</i></span
                >
                <input
                  type="number"
                  v-if="hasPrivilege('accounting_change_price')"
                  @input="updateExpiration"
                  v-model="profile_price"
                  class="form-control phone-mask"
                  placeholder="1"
                  aria-label="1"
                  aria-describedby="basic-icon-default-phone2"
                />
                <input
                  v-else
                  type="number"
                  class="form-control phone-mask"
                  disabled
                  :value="temp_profile_price"
                />
              </div>
            </div>
            <div
              class="col-md-6"
              v-if="
                hasPrivilege('accounting_pay_bill') && user.type != 'reseller'
              "
            >
              <label class="form-label" for="basic-icon-default-phone">{{
                $t("transactions.discount")
              }}</label>
              <div class="input-group input-group">
                <span class="input-group-text"
                  ><i class="ti ti-rosette-discount"></i
                ></span>
                <input
                  type="number"
                  v-model="discount"
                  class="form-control phone-mask"
                  placeholder="1"
                  aria-label="1"
                  aria-describedby="basic-icon-default-phone2"
                />
              </div>
            </div>
            <div class="col-12" v-if="calculated_values.profile_changed">
              <a
                @click.prevent="calculated_values.show = true"
                class="text-xs"
                >{{ $t("profiles.change_profile_values.details") }}</a
              >
              <div v-if="calculated_values.show">
                <div>
                  {{ $t("profiles.change_profile_values.old_price") }}
                  {{ old_profile.price }}
                </div>
                <div>
                  {{ $t("profiles.change_profile_values.new_price") }}
                  {{ temp_profile.price }}
                </div>
                <div>
                  {{ $t("profiles.change_profile_values.billed_days") }}
                  {{ calculated_values.billed_days }}
                </div>
                <div>
                  {{ $t("profiles.change_profile_values.new_days") }}
                  {{ calculated_values.new_days }}
                </div>
                <div>
                  {{ $t("profiles.change_profile_values.billed_days_price") }}
                  {{
                    calculated_values.billed_day_price *
                      calculated_values.billed_days
                  }}
                </div>
                <div>
                  {{ $t("profiles.change_profile_values.new_days_price") }}
                  {{
                    calculated_values.new_day_price * calculated_values.new_days
                  }}
                </div>
              </div>
            </div>
            <div
              v-if="
                in_debt &&
                  hasPrivilege('accounting_pay_bill') &&
                  user.type != 'reseller'
              "
            >
              <label class="form-label" for="basic-icon-default-phone">{{
                $t("transactions.paid_amount")
              }}</label>
              <div class="input-group input-group">
                <span class="input-group-text"
                  ><i class="ti ">{{ settings.currency }}</i></span
                >
                <input
                  type="number"
                  v-model="paid"
                  class="form-control phone-mask"
                  placeholder="1"
                  aria-label="1"
                  aria-describedby="basic-icon-default-phone2"
                />
              </div>
            </div>
            <!-- Reseller Benefit  -->
            <div v-if="user.type == 'reseller'">
              <label class="form-label" for="basic-icon-default-phone">{{
                $t("control.benefit")
              }}</label>
              <div class="input-group input-group">
                <span class="input-group-text"
                  ><i class="ti">{{ settings.currency }}</i></span
                >
                <div class="form-control">
                  {{
                    (temp_profile_price * renew_amount * user.benefit_rate) /
                      100
                  }}
                </div>
              </div>
            </div>
            <!-- /// -->
            <!-- Reseller Benefit From Admin  -->
            <div
              v-if="
                this.user.type != 'reseller' &&
                  selectedAccount.reseller_id != null
              "
            >
              <label class="form-label" for="basic-icon-default-phone">{{
                $t("control.benefit")
              }}</label>
              <div class="input-group input-group">
                <span class="input-group-text"
                  ><i class="ti">{{ settings.currency }}</i></span
                >
                <div class="form-control">
                  {{
                    (temp_profile_price * renew_amount * user.benefit_rate) /
                      100
                  }}
                </div>
              </div>
            </div>
            <!-- /// -->
            <!-- Reseller Cost  -->
            <div v-if="this.user.type == 'reseller'">
              <label class="form-label" for="basic-icon-default-phone"
                >Operation Cost</label
              >
              <div class="input-group input-group">
                <span class="input-group-text"
                  ><i class="ti">{{ settings.currency }}</i></span
                >
                <div class="form-control">
                  {{
                    temp_profile_price * renew_amount -
                      (temp_profile_price * renew_amount * user.benefit_rate) /
                        100
                  }}
                </div>
              </div>
            </div>
            <!-- /// -->

            <div
              v-if="
                this.user.type != 'reseller' &&
                  hasPrivilege('accounts_edit_expiration_accounts')
              "
            >
              <label for="flatpickr-datetime" class="form-label">{{
                $t("accounts.expires_at")
              }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-calendar-time"></i>
                </div>
                <input
                  v-model="date"
                  type="datetime-local"
                  class="form-control"
                  placeholder="YYYY-MM-DD HH:MM"
                  :disabled="
                    this.user.type == 'reseller' ||
                      !hasPrivilege('accounts_edit_expiration_accounts')
                  "
                />
              </div>
            </div>
            <div v-if="calculated_values.profile_changed">
              <div class="form-check custom-option custom-option-basic">
                <label
                  class="form-check-label custom-option-content"
                  for="paid"
                >
                  <input
                    name="customRadioTemp"
                    class="form-check-input"
                    type="checkbox"
                    v-model="add_days"
                    @change="validate()"
                  />
                  <span class="h6">
                    {{ $t("profiles.add_days") }}
                  </span>
                </label>
              </div>
            </div>
            <div>
              <div class="form-check custom-option custom-option-basic">
                <label
                  class="form-check-label custom-option-content"
                  for="paid"
                >
                  <input
                    name="customRadioTemp"
                    class="form-check-input"
                    type="checkbox"
                    @change="updateExpiration()"
                    v-model="keep_old_date"
                  />
                  <span class="h6">
                    {{ $t("profiles.keep_old_expiration_date") }}
                  </span>
                </label>
              </div>
            </div>
            <div
              v-if="
                hasPrivilege('profiles_save_quota') &&
                  temp_profile.traffic_limited
              "
            >
              <label class="form-label" for="basic-icon-default-phone">{{
                $t("control.remaining_quota")
              }}</label>
              <div class="row">
                <div>
                  <div class="form-check custom-option custom-option-basic">
                    <label
                      class="form-check-label custom-option-content"
                      for="paid"
                    >
                      <input
                        name="customRadioTemp"
                        class="form-check-input"
                        type="checkbox"
                        :value="true"
                        v-model="previous_quota"
                      />
                      <span class="custom-option-header">
                        <span class="h6 mb-0">{{
                          $t("control.save") +
                            " " +
                            $t("control.remaining_quota")
                        }}</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 text-center">
              <button
                v-if="!confirmation"
                @click.prevent="confirmation = true"
                type="submit"
                class="btn btn-primary"
                :class="{ 'bg-opacity-50 cursor-default': !validated }"
                :disabled="!validated"
              >
                {{ $t("profiles.renew.renew") }}
              </button>
            </div>
            <div
              v-if="confirmation"
              class="grid grid-cols-2 gap-x-2 w-full md:w-1/3 items-center justify-center"
            >
              <div class="col-span-2 flex justify-center text-center">
                {{ $t("profiles.renew.confirm") }}
              </div>
              <div
                v-if="
                  !in_debt &&
                    hasPrivilege('accounting_pay_bill') &&
                    user.type != 'reseller'
                "
                class="col-span-2 flex justify-center text-center text-xl"
              >
                {{ $t("profiles.renew.debt_confirm") }}
              </div>
              <div
                v-if="
                  in_debt &&
                    profile.price * renew_amount -
                      (profile.price * renew_amount * user.benefit_rate) / 100 >
                      paid &&
                    hasPrivilege('accounting_pay_bill') &&
                    user.type != 'reseller'
                "
                class="col-span-2 flex justify-center text-center"
              >
                {{ $t("profiles.renew.paid_debt_confirm") }}
              </div>
              <!-- <div
                class="btn-group col-span-2"
                role="group"
                aria-label="Basic example"
              >
                <button
                  @click.prevent="confirmation = false"
                  class="btn btn-danger"
                >
                  {{ $t("control.no") }}
                </button>
                <button @click.prevent="store" class="btn btn-success">
                  {{ $t("control.yes") }}
                </button>
              </div> -->
              <div class="col-12 text-center col-span-2">
                <button
                  type="button"
                  class="btn btn-primary me-3"
                  @click.prevent="store"
                >
                  {{ $t("control.submit") }}
                </button>
                <button
                  type="reset"
                  class="btn btn-label-secondary"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  @click="confirmation = false"
                >
                  {{ $t("control.cancel") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import ExpiredWindow from "./ExpiredWindow.vue";
import { hasPrivilege } from "../../global_constants.js";
export default {
  components: {
    ExpiredWindow,
  },
  props: ["selectedAccount", "visible"],
  name: "renewAccountProfile",
  computed: {
    ...mapGetters(["user", "settings"]),
    date_time() {
      return this.date ? this.date.format("YYYY-MM-DD HH:mm:ss") : null;
    },
  },
  data() {
    return {
      renew_amount: 1,
      profiles: null,
      date: null,
      time: {
        hours: 0,
        minutes: 0,
      },
      startTime: {
        hours: 0,
        minutes: 0,
      },
      in_debt: true,
      paid: 0,
      discount: 0,
      profile_price: 0,
      previous_quota: false,
      confirmation: false,
      loading: true,
      old_expiration: null,
      old_profile: null,
      format: (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();

        return `${day}-${month}-${year}`;
      },
      validated: true,
      profile: null,
      add_days: true,
      keep_old_date: false,
      expiring_soon: true,
      calculated_values: {
        profile_changed: false,
        remaining_days: 0,
        billed_days: 0,
        new_days: 0,
        new_day_price: 0,
        billed_day_price: 0,
        calculated_days_price: 0,
      },
      errors: {
        renew_amount: null,
      },
      temp_profile: null,
      temp_profile_price: 0,
    };
  },
  // computed: {
  //   required_money() {
  //     var t1 = this.temp_profile.price * this.renew_amount;
  //     var t2 =
  //       (this.temp_profile.price *
  //         this.renew_amount *
  //         this.user.benefit_rate) /
  //       100;
  //     return t1 - t2;
  //   },
  // },
  async created() {
    await this.fetchProfiles();
    this.loading = false;
    this.profile = this.selectedAccount.profile;
    this.old_expiration = this.selectedAccount.expires_at;
    this.old_profile = { ...this.profile };
    this.updateExpiration();
    if (this.profile.expiration_unit != "hours")
      this.time.hours = this.settings.default_expiration_hour ?? 12;
    this.temp_profile = this.selectedAccount.profile;
    this.validate();
    this.renew_amount = 1;
    var days_to_expire = moment
      .duration(moment(this.selectedAccount.expires_at).diff(moment()))
      .asDays();
    if (days_to_expire > 10) {
      this.expiring_soon = false;
    }
  },
  methods: {
    hide() {
      this.$emit("hide-details");
    },
    formatDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    updateExpiration() {
      var profile = this.profiles.find(
        (e) => e.id == this.selectedAccount.profile.id
      );
      if (
        moment(this.selectedAccount.expires_at).add(
          this.selectedAccount.wait_days,
          "days"
        ) > moment()
      ) {
        this.date = moment(this.selectedAccount.expires_at).add(
          profile.expiration_value * this.renew_amount,
          profile.expiration_unit
        );
        if (this.keep_old_date) {
          this.date = moment(this.selectedAccount.expires_at).add(
            profile.expiration_value * this.renew_amount,
            profile.expiration_unit
          );
        }
        if (this.profile.expiration_unit != "hours") {
          this.date.hours(this.settings.default_expiration_hour ?? 12);
        } else {
          // this.date.hours(
          //   this.date.hour + profile.expiration_value * this.renew_amount
          // );
        }
        this.date.minutes(0);
      } else {
        this.date = moment().add(
          profile.expiration_value * this.renew_amount,
          profile.expiration_unit
        );
        if (this.keep_old_date) {
          this.date = moment(this.selectedAccount.expires_at).add(
            profile.expiration_value * this.renew_amount,
            profile.expiration_unit
          );
        }
        if (this.profile.expiration_unit != "hours") {
          this.date.hours(this.settings.default_expiration_hour ?? 12);
        } else {
          // this.date.hours(
          //   this.date.hour + profile.expiration_value * this.renew_amount
          // );
        }
        this.date.minutes(0);
      }
      this.paid = this.hasPrivilege("accounting_change_price")
        ? profile.price
        : profile.price * this.renew_amount;
      this.profile = profile;
      this.profile_price = this.profile.price * this.renew_amount;
      this.date = this.date.format("YYYY-MM-DD HH:mm:ss");
    },
    updateProfile() {
      this.temp_profile = this.profiles.find(
        (e) => e.id == this.selectedAccount.profile.id
      );
      this.temp_profile_price = this.temp_profile.price;
    },
    async store() {
      if (this.loading) return;
      this.loading = true;
      this.date = moment(this.date);
      if (this.profile.expiration_unit != "hours") {
        this.date.hours(this.time.hours);
        this.date.minutes(this.time.minutes);
      }
      // console.log(moment(this.date).format("yyyy-MM-DD HH:mm"));
      // return;
      const response = await axios.post(
        `/accounts/${this.selectedAccount.id}/renew`,
        {
          profile_id: this.selectedAccount.profile.id,
          expires_at: moment(this.date).format("yyyy-MM-DD HH:mm"),
          profile_price: this.profile_price,
          renew_amount: this.renew_amount,
          in_debt: !this.in_debt,
          paid_amount: this.paid,
          discount: this.discount,
          previous_quota: this.previous_quota,
          next_profile_id: this.selectedAccount.next_profile_id,
          add_days: this.add_days,
          keep_old_date: this.keep_old_date,
        }
      );
      if (response.status == 200) {
        const userResponse = await axios.get("user");
        this.$store.dispatch("user", userResponse.data.data);
        document.getElementById("renew-account-close").click();
        this.$emit("updated", response.data.bill);
        this.loading = false;
      }
    },
    async fetchProfiles() {
      const response = await axios.get("/profiles?rows=1000000&itr=true");
      if (response.status == 200) this.profiles = response.data.data;
    },
    validate() {
      this.validated = true;
      this.calculated_values.profile_changed = false;
      this.temp_profile_price = this.temp_profile.price;
      this.profile_price = this.temp_profile_price;
      this.errors.renew_amount = null;
      if (
        this.old_profile.id != this.selectedAccount.profile.id &&
        moment(this.selectedAccount.expires_at) > moment()
      ) {
        this.calculated_values.profile_changed = true;
        if (!this.add_days) {
          this.date = moment(this.old_expiration).format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.updateExpiration();
        }
        this.calculated_values.remaining_days = Math.abs(
          moment().diff(moment(this.date), "days")
        );
        this.calculated_values.billed_days = Math.abs(
          moment().diff(moment(this.old_expiration), "days")
        );
        this.calculated_values.new_days =
          this.calculated_values.remaining_days -
          this.calculated_values.billed_days;
        this.calculated_values.new_day_price = this.temp_profile.price / 30;
        this.calculated_values.billed_day_price =
          this.temp_profile.price / 30 - this.old_profile.price / 30;
        this.calculated_values.calculated_days_price =
          this.calculated_values.new_day_price *
            this.calculated_values.new_days +
          this.calculated_values.billed_day_price *
            this.calculated_values.billed_days;
        this.profile_price = this.calculated_values.calculated_days_price;
        this.paid = this.profile_price;
        this.temp_profile_price = this.profile_price;
        // this.renew_amount =
        //   Math.abs(moment().diff(moment(this.date), "days")) / 30;
      }

      if (!this.add_days && this.calculated_values.profile_changed) {
        this.profile_price = this.temp_profile.price * this.renew_amount;
        this.paid = this.profile_price;
      }
      if (
        this.user.money -
          this.temp_profile_price +
          (this.temp_profile_price * this.user.benefit_rate) / 100 <
          0 &&
        this.user.type == "reseller"
      ) {
        this.validated = false;
      }
      if (this.renew_amount <= 0) {
        this.errors.renew_amount = this.$t("errors.required");
        this.validated = false;
      }
    },
  },
};
</script>
